import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
  NO_ERRORS_SCHEMA,
  Provider
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MSAL_INSTANCE, MsalModule, MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { RecordRequestsComponent } from './components/record-requests/record-requests.component';
import { ShareFilesSpokeComponent } from './components/share-files-spoke/share-files-spoke.component';

import _rg4js from 'raygun4js';
const rg4js = _rg4js as any; // type defs don't cover all command strings (configure)
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { StudiesModule } from './studies/studies.module';
import { AppComponent } from './app.component';
import { RaygunErrorHandler } from './app.raygun.setup';
import { ActiveConsultantComponent } from './components/active-consultant/active-consultant.component';
import { AddAttachmentsComponent } from './components/add-attachments/add-attachments.component';
import { AddCommentsComponent } from './components/add-comments/add-comments.component';
import { AddContactComponent } from './components/add-contact/add-contact.component';
import { AddDiagnosisDocumentsComponent } from './components/add-diagnosis-documents/add-diagnosis-documents.component';
import { AddDiagnosisComponent } from './components/add-diagnosis/add-diagnosis.component';
import { AddLibraryWebSourceComponent } from './components/add-library-web-source/add-library-web-source.component';
import { AddMedicationComponent } from './components/add-medication/add-medication.component';
import { AllusersComponent } from './components/allusers/allusers.component';
import { AnnuallyMonthlySwitchComponent } from './components/annually-monthly-switch/annually-monthly-switch.component';
import { FacilitiesListComponent } from './components/facilities-list/facilities-list.component';
import { InviteFacilityDialogComponent } from './components/facilities-list/invite-facility-dialog/invite-facility-dialog.component';
import { EditFacilityOwnerDialogComponent } from './components/facilities-list/edit-facility-owner-dialog/edit-facility-owner-dialog.component';
import { JoinPageComponent } from './components/join-page/join-page.component';
import { AttorneysLawFirmsComponent } from './components/attorneys-law-firms/attorneys-law-firms.component';
import { AuditLogFilterByUserComponent } from './components/audit-log-filter-by-user/audit-log-filter-by-user.component';
import { AuditLogViewerComponent } from './components/audit-log-viewer/audit-log-viewer.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ChooseTargetDirectoryComponent } from './components/choose-target-directory/choose-target-directory.component';
import { ClientListItemComponent } from './components/client-list-item/client-list-item.component';
import { ClientMatterDataInfoComponent } from './components/client-matter-data-info/client-matter-data-info.component';
import { ClientMatterInfoComponent } from './components/client-matter-info/client-matter-info.component';
import { ClientProfileComponent } from './components/clientprofile/clientprofile.component';
import { PatientShareDocumentsComponent } from './components/patient-share-documents/patient-share-documents.component';
import { PatientRetrieveDocumentsComponent } from './components/patient-retrieve-documents/patient-retrieve-documents.component';
import { PatientDocumentsFlowComponent } from './components/patient-documents-flow/patient-documents-flow.component';
import { ComparePlansColumnsComponent } from './components/compare-plans-columns/compare-plans-columns.component';
import { PatientIdsDialogComponent } from './components/patient-ids-dialog/patient-ids-dialog.component';
import { ShareFilesStep2UserSelectionComponent } from './components/share-files-step2-user-selection/share-files-step2-user-selection.component';
import { ShareFilesComponent } from './components/share-files/share-files.component';
import { SharedFilesDialogComponent } from './components/shared-files-dialog/shared-files-dialog.component';
import { SharedUsersDialogComponent } from './components/shared-users-dialog/shared-users-dialog.component';
import { FacilityUserSelectionMockComponent } from './components/facility-user-selection-mock/facility-user-selection-mock.component';

import { ComparePlansTableComponent } from './components/compare-plans-table/compare-plans-table.component';
import { ConsultantByClientComponent } from './components/consultant-by-client/consultant-by-client.component';
import { CreateCuaUserComponent } from './components/create-cua-user/create-cua-user.component';
import { CreateFacilityUserComponent } from './components/create-facility-user/create-facility-user.component';
import { CreateFacilityComponent } from './components/create-facility/create-facility.component';
import { CreateFacilityFormComponent } from './components/create-facility-form/create-facility-form.component';
import { FacilitySetupComponent } from './components/facility-setup/facility-setup.component';
import { CreateZoomMeetingFormComponent } from './components/create-zoom-meeting-form/create-zoom-meeting-form.component';
import { CreateadminComponent } from './components/createadmin/createadmincomponent';
import { CreateclientComponent } from './components/createclient/createclient.component';
import { CreatepatientComponent } from './components/createpatient/createpatient.component';
import { CreateuserComponent } from './components/createuser/createuser.component';
import { CustomFoldersComponent } from './components/custom-folders/custom-folders.component';
import { DefaultCalendarSetUpComponent } from './components/default-calendar-set-up/default-calendar-set-up.component';
import { DiagnosisLinkComponent } from './components/diagnosis-link/diagnosis-link.component';
import { EditClientFormComponent } from './components/edit-client-form/edit-client-form.component';
import { EditFileDialogComponent } from './components/edit-file-dialog/edit-file-dialog.component';
import { EditNoteComponent } from './components/edit-note/edit-note.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { FeedLibraryComponent } from './components/feed-library/feed-library.component';
import { ExchangerSwitchComponent } from './components/exchanger-switch/exchanger-switch.component';
import { TransferVisualizationComponent } from './components/transfer-visualization/transfer-visualization.component';
import { FgpasswordComponent } from './components/fgpassword/fgpassword.component';
import { FileCommentsAttachmentsListComponent } from './components/file-comments-attachments-list/file-comments-attachments-list.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { FilterSearchComponent } from './components/filter-search/filter-search.component';
import { FolderLinkComponent } from './components/folder-link/folder-link.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeFoldersAccordionFacilitatorsComponent } from './components/home-folders-accordion-facilitators/home-folders-accordion-facilitators.component';
import { GetExtensionComponent } from './components/get-extension/get-extension.component';
import { SpokeOwnerOnboardingDialogComponent } from './components/spoke-owner-onboarding-dialog/spoke-owner-onboarding-dialog.component';
import { HomeFoldersAccordionSpokesComponent } from './components/home-folders-accordion-spokes/home-folders-accordion-spokes.component';
import { SharedDocumentsComponent } from './components/shared-documents/shared-documents.component';
import { OldPatientOverviewComponent } from './components/old-patient-overview/old-patient-overview.component';
import { HomeFoldersAccordionComponent } from './components/home-folders-accordion/home-folders-accordion.component';
import { DocumentsToShareComponent } from './components/documents-to-share/documents-to-share.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { HubSelectorComponent } from './components/hub-selector/hub-selector.component';
import { InfoWindowComponent } from './components/info-window/info-window.component';
import { JsonToTableComponent } from './components/json-to-table/json-to-table.component';
import { LibraryManagementComponent } from './components/library-management/library-management.component';
import { TransferComponent } from './components/library-management/transfer/transfer.component';
import { UploadComponent } from './components/library-management/upload/upload.component';
import { LibraryComponent } from './components/library/library.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { MaintenancePageComponent } from './components/maintenance/maintenance.page';
import { MedicalStudiesListComponent } from './components/medical-studies-list/medical-studies-list.component';
import { MeetingsPageComponent } from './components/meetings-page/meetings-page.component';
import { NewFolderComponent } from './components/new-folder/new-folder.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { OtherPlansDetailsComponent } from './components/other-plans-details/other-plans-details.component';
import { PatientDialogComponent } from './components/patient-dialog/patient-dialog.component';
import { PatientIdCardComponent } from './components/patient-ids/patient-id-card/patient-id-card.component';
import { PatientIdsComponent } from './components/patient-ids/patient-ids.component';
import { PatientBasicInfoComponent } from './components/patient-overview/patient-basic-info/patient-basic-info.component';
import { PatientOverviewComponent } from './components/patient-overview/patient-overview.component';
import { PatientOverviewVersionDialogComponent } from './components/patient-overview-version-dialog/patient-overview-version-dialog.component';
import { PatientOverviewV2Component } from './components/patient-overview-v2/patient-overview-v2.component';
import { PatientOverviewNavigationComponent } from './components/patient-overview-navigation/patient-overview-navigation.component';
import { DecisionButtonsComponent } from './components/decision-buttons/decision-buttons.component';
import { PatientsActionsComponent } from './components/patients-actions/patients-actions.component';
import { PatientTransferInfoComponent } from './components/patient-transfer-info/patient-transfer-info.component';
import { FacilityUsersComponent } from './components/facility-users/facility-users.component';
import { PatientsActionsButtonsComponent } from './components/patients-actions-buttons/patients-actions-buttons.component';
import { PatientsActionsFacilityComponent } from './components/patients-actions-facility/patients-actions-facility.component';
import { FacilityListComponent } from './components/patients-actions-facility/facility-list/facility-list.component';
import { SendTargetDialogComponent } from './components/send-target-dialog/send-target-dialog.component';
import { ChangeTargetDialogComponent } from './components/change-target-dialog/change-target-dialog.component';
import { PatientShareFilesComponent } from './components/patient-share-files/patient-share-files.component';
import { PatientRetrieveFilesComponent } from './components/patient-retrieve-files/patient-retrieve-files.component';
import { PagerSetupComponent } from './components/pager-setup/pager-setup.component';
import { SharingSetupComponent } from './components/sharing-setup/sharing-setup.component';
import { FacilityAnimationComponent } from './components/facility-animation/facility-animation.component';
import { PatientsListComponent } from './components/patients-list/patients-list.component';
import { PlanDetailsComponent } from './components/plan-details/plan-details.component';
import { PlansDataComponent } from './components/plans-data/plans-data.component';
import { PricingTableHeaderComponent } from './components/pricing-table-header/pricing-table-header.component';
import { PricingTableMobileComponent } from './components/pricing-table-mobile/pricing-table-mobile.component';
import { PlansButtonsComponent } from './components/pricing/plans-buttons/plans-buttons.component';
import { ProgressLoaderComponent } from './components/progress-loader/progress-loader.component';
import { PromptUser2FACodeComponent } from './components/prompt-user2-facode/prompt-user2-facode.component';
import { ReportComponent } from './components/report/report.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SearchFilesComponent } from './components/search-files/search-files.component';
import { SearchComponent } from './components/search/search.component';
import { SelectExistingFacilityComponent } from './components/select-existing-facility/select-existing-facility.component';
import { SelectOwnerComponent } from './components/select-owner/select-owner.component';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';
import { SetNewAccountPasswordComponent } from './components/set-new-account-password/set-new-account-password.component';
import { ShareFilesStep1FacilitySelectionComponent } from './components/share-files-step1-facility-selection/share-files-step1-facility-selection.component';
import { ShowDiagnosisDocumentsComponent } from './components/show-diagnosis-documents/show-diagnosis-documents.component';
import { ShowMedicationComponent } from './components/show-medication/show-medication.component';
import { ShowMyDiagnosesComponent } from './components/show-my-diagnoses/show-my-diagnoses.component';
import { ShowMyDiagnosisComponent } from './components/show-my-diagnosis/show-my-diagnosis.component';
import { ShowUserInfoComponent } from './components/show-user-info/show-user-info.component';
import { SigninComponent } from './components/signin/signin.component';
import { SpokesSearchComponent } from './components/spokes-search/spokes-search.component';
import { StudyLinkComponent } from './components/study-link/study-link.component';
import { TwoFactorAuthRequestDialogComponent } from './components/two-factor-auth-request/two-factor-auth-request.dialog';
import { TwoFactorAuthSetupDialogComponent } from './components/two-factor-auth-setup-dialog-component/two-factor-auth-setup-dialog.component';
import { TwoFactorSignInModalComponent } from './components/two-factor-sign-in-modal/two-factor-sign-in-modal.component';
import { AllNotesDialogComponent } from './components/ui/all-notes-dialog/all-notes-dialog.component';
import { BlueAsteriskComponent } from './components/ui/blue-asterisk/blue-asterisk.component';
import { CheckImageComponent } from './components/ui/check-image/check-image.component';
import { ChooseLibraryCategoryComponent } from './components/ui/choose-library-category/choose-library-category.component';
import { ChoosePlanButtonComponent } from './components/ui/choose-plan-button/choose-plan-button.component';
import { ClientProfileToolbarComponent } from './components/ui/client-profile-toolbar/client-profile-toolbar.component';
import { ClientProfileTopButtonsComponent } from './components/ui/client-profile-top-buttons/client-profile-top-buttons.component';
import { InfectedFilesSectionComponent } from './components/ui/infected-files-section/infected-files-section.component';
import { ShareButtonComponent } from './components/ui/share-button/share-button.component';
import { ConfirmationDialogComponent } from './components/ui/confirmation-dialog/confirmation-dialog.component';
import { DocViewerNoDataComponent } from './components/ui/doc-viewer-no-data/doc-viewer-no-data.component';
import { DocViewerComponent } from './components/ui/doc-viewer/doc-viewer.component';
import { DragAndDropUploadComponent } from './components/ui/drag-and-drop-upload/drag-and-drop-upload.component';
import { FilesComparisonComponent } from './components/ui/files-comparison/files-comparison.component';
import { FolderSelectorComponent } from './components/ui/folder-selector/folder-selector.component';
import { GoToDownloadLocationComponent } from './components/ui/go-to-download-location/go-to-download-location.component';
import { HowToBurnADiscComponent } from './components/ui/how-to-burn-a-disc/how-to-burn-a-disc.component';
import { HowToBurnADiscStepsComponent } from './components/ui/how-to-burn-adisc-steps/how-to-burn-adisc-steps.component';
import { InputFileComponent } from './components/ui/inputfile/inputfile.component';
import { NoteDialogComponent } from './components/ui/note-dialog/note-dialog.component';
import { OptionChooserComponent } from './components/ui/optionChooser/optionChooser.component';
import { PatientIdDisplayComponent } from './components/ui/patient-id-display/patient-id-display.component';
import { PatientIdentificationLabelsComponent } from './components/ui/patient-identification-labels/patient-identification-labels.component';
import { PromptLinkComponent } from './components/ui/prompt-link/prompt-link.component';
import { ShowStudiesDialogComponent } from './components/ui/show-studies-dialog/show-studies-dialog.component';
import { SimpleListSelectionComponent } from './components/ui/simple-list-selection/simple-list-selection.component';
import { SimpleMessageWindowComponent } from './components/ui/simple-message-window/simple-message-window.component';
import { UploadDialogComponent } from './components/ui/uploaddialog/uploaddialog.component';
import { WindowTitleComponent } from './components/ui/window-title/window-title.component';
import { JoinNuageDxNetworkComponent } from './components/ui/join-nuagedx-network/join-nuagedx-network.component';
import { UpdateUserPasswordComponent } from './components/update-user-password/update-user-password.component';
import { UpgradePlanComponent } from './components/upgrade-plan/upgrade-plan.component';
import { UploadProgressComponent } from './components/upload-progress/upload-progress.component';
import { ViewNoteComponent } from './components/view-note/view-note.component';
import { VOBInfoWindowComponent } from './components/vob-info-window/vob-info-window.component';
import { AutoForwardingSectionComponent } from './components/auto-forwarding/auto-forwarding-section/auto-forwarding-section.component';
import { ConfigureAutoForwardDialogComponent } from './components/auto-forwarding/configure-auto-forward-dialog/configure-auto-forward-dialog.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { LibraryCategoriesComponent } from './library-categories/library-categories.component';
import { LoaderComponent } from './loader/loader.component';
import { OAuthSettings } from './oauth/microsoft.oauth';
import { FileSizePipe } from './pipes/file-size.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AuthService } from './services/auth.service';
import { ReportService } from './services/report.service';
import { SearchService } from './services/search.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from './auth-token.interceptor';
import { SendInstructionsComponent } from './send-instructions/send-instructions.component';
import { RetrieveInstructionsComponent } from './retrieve-instructions/retrieve-instructions.component';
// import { default } from '../environments/env';

let msalInstance: IPublicClientApplication | undefined;

const isProduction = window.location.hostname === 'medical.nuagedx.com';
console.log('isProduction: ', isProduction);

/**
 * Local-only error handler. Registered in place of RaygunErrorHandler so that
 * errors never reach Angular's default handleError → console.error path, which
 * is wrapped by Raygun's breadcrumb collector and shows raygun.umd.js:N as the
 * source in the console.
 *
 * - PERMISSION_DENIED from the notifications WebSocket is swallowed (benign background noise).
 * - All other errors are forwarded to console.warn so they remain visible but
 *   use a different console method that Raygun does not intercept.
 */
class DevErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const msg: string = error?.message ?? String(error);
    if (error?.code === 'permission-denied' || msg.includes('Missing or insufficient permissions')) {
      return; // benign — notifications listener fires when user has no access
    }
    // Use console.warn so the real file:line appears as the source instead of
    // raygun.umd.js (Raygun only wraps console.error, not console.warn).
    console.warn('[DEV ERROR]', error);
  }
}

const providers: Provider[] = [
  AuthService,
  SearchService,
  ReportService,
  { provide: MatDialogRef, useValue: {} },
  { provide: MAT_DIALOG_DATA, useValue: [] },
  { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
  { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
  MsalService,
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill', floatLabel: 'always' } }
];

export function setupRaygun() {
  return async () => {
    if (window.location.hostname !== 'medical.nuagedx.com') {
      return;
    }
    rg4js('configure', {
      apiKey: 'i4hDHQhvRAAtDQ6JZSnVVQ',
      enablePulse: true,
      ignoreAjaxAbort: true,
      ignoreAjaxError: true
    });
  };
}

export function MSALInstanceFactory(): IPublicClientApplication {
  msalInstance =
    msalInstance ??
    new PublicClientApplication({
      auth: {
        clientId: OAuthSettings.appId,
        redirectUri: OAuthSettings.redirectUri
      }
    });
  return msalInstance;
}

@NgModule({ declarations: [
        GoToDownloadLocationComponent,
        GetExtensionComponent,
        SpokeOwnerOnboardingDialogComponent,
        HowToBurnADiscComponent,
        HowToBurnADiscStepsComponent,
        ClientProfileToolbarComponent,
        ClientProfileTopButtonsComponent,
        InfectedFilesSectionComponent,
        ShareButtonComponent,
        PlansDataComponent,
        StudyLinkComponent,
        DiagnosisLinkComponent,
        FolderLinkComponent,
        ShowMyDiagnosisComponent,
        PricingTableHeaderComponent,
        PricingTableMobileComponent,
        OtherPlansDetailsComponent,
        PlanDetailsComponent,
        AutoFocusDirective,
        AppComponent,
        SelectOwnerComponent,
        SigninComponent,
        FgpasswordComponent,
        CreateclientComponent,
        ShowDiagnosisDocumentsComponent,
        AddDiagnosisDocumentsComponent,
        CreateuserComponent,
        CreateFacilityUserComponent,
        SelectExistingFacilityComponent,
        CreateadminComponent,
        FooterComponent,
        HeaderComponent,
        CreatepatientComponent,
        SearchComponent,
        FolderSelectorComponent,
        SpokesSearchComponent,
        BreadcrumbComponent,
        AllusersComponent,
        FacilitiesListComponent,
        InviteFacilityDialogComponent,
        EditFacilityOwnerDialogComponent,
        JoinPageComponent,
        ReportComponent,
        ConfirmationDialogComponent,
        UpdateUserPasswordComponent,
        InputFileComponent,
        UploadDialogComponent,
        NewFolderComponent,
        NoteDialogComponent,
        AllNotesDialogComponent,
        ShowStudiesDialogComponent,
        DragAndDropUploadComponent,
        MeetingsPageComponent,
        UploadProgressComponent,
        EditFileDialogComponent,
        ConsultantByClientComponent,
        InfoWindowComponent,
        MaintenancePageComponent,
        EditNoteComponent,
        ChooseTargetDirectoryComponent,
        CustomFoldersComponent,
        SearchFilesComponent,
        DefaultCalendarSetUpComponent,
        CreateZoomMeetingFormComponent,
        HomePageComponent,
        LoginPageComponent,
        LoaderComponent,
        CreateFacilityComponent,
        CreateFacilityFormComponent,
        FacilitySetupComponent,
        ProgressLoaderComponent,
        EditClientFormComponent,
        EditProfileComponent,
        TwoFactorAuthRequestDialogComponent,
        TwoFactorAuthSetupDialogComponent,
        PromptUser2FACodeComponent,
        TwoFactorSignInModalComponent,
        SimpleMessageWindowComponent,
        OptionChooserComponent,
        JoinNuageDxNetworkComponent,
        UpgradePlanComponent,
        SessionTimeoutComponent,
        SafeHtmlPipe,
        SafePipe,
        FileSizePipe,
        AuditLogViewerComponent,
        AuditLogFilterByUserComponent,
        JsonToTableComponent,
        ShowUserInfoComponent,
        ResetPasswordComponent,
        AddContactComponent,
        SimpleListSelectionComponent,
        DocViewerComponent,
        DocViewerNoDataComponent,
        FilesComparisonComponent,
        ClientMatterInfoComponent,
        MedicalStudiesListComponent,
        ClientListItemComponent,
        PatientIdsDialogComponent,
        CreateCuaUserComponent,
        ViewNoteComponent,
        AddAttachmentsComponent,
        AddCommentsComponent,
        FileViewerComponent,
        FileCommentsAttachmentsListComponent,
        ClientMatterDataInfoComponent,
        AttorneysLawFirmsComponent,
        NotificationsComponent,
        ActiveConsultantComponent,
        ExchangerSwitchComponent,
        TransferVisualizationComponent,
        CheckImageComponent,
        BlueAsteriskComponent,
        ChoosePlanButtonComponent,
        PlansButtonsComponent,
        AnnuallyMonthlySwitchComponent,
        ComparePlansTableComponent,
        ComparePlansColumnsComponent,
        LibraryComponent,
        PatientDialogComponent,
        PatientsListComponent,
        AutoForwardingSectionComponent,
        ConfigureAutoForwardDialogComponent,
        LibraryManagementComponent,
        TransferComponent,
        UploadComponent,
        FeedLibraryComponent,
        FilterSearchComponent,
        PromptLinkComponent,
        ChooseLibraryCategoryComponent,
        SetNewAccountPasswordComponent,
        AddDiagnosisComponent,
        ShowMyDiagnosesComponent,
        AddMedicationComponent,
        ShowMedicationComponent,
        AddLibraryWebSourceComponent,
        PatientOverviewComponent,
        OldPatientOverviewComponent,
        PatientOverviewVersionDialogComponent,
        DecisionButtonsComponent,
        PatientsActionsComponent,
        PatientTransferInfoComponent,
        FacilityUsersComponent,
        PatientsActionsButtonsComponent,
        PatientsActionsFacilityComponent,
        FacilityListComponent,
        SendTargetDialogComponent,
        ChangeTargetDialogComponent,
        PatientShareFilesComponent,
        PatientRetrieveFilesComponent,
        PatientBasicInfoComponent,
        ClientProfileComponent,
        PatientShareDocumentsComponent,
        PatientRetrieveDocumentsComponent,
        PatientDocumentsFlowComponent,
        HomeFoldersAccordionComponent,
        DocumentsToShareComponent,
        HomeFoldersAccordionFacilitatorsComponent,
        HomeFoldersAccordionSpokesComponent,
        SharedDocumentsComponent,
        SharedUsersDialogComponent,
        SharedFilesDialogComponent,
        ShareFilesComponent,
        ShareFilesSpokeComponent,
        ShareFilesStep2UserSelectionComponent,
        HubSelectorComponent,
        PatientIdCardComponent,
        PatientIdsComponent,
        PatientIdentificationLabelsComponent,
        PatientIdDisplayComponent,
        PagerSetupComponent,
        SharingSetupComponent,
        FacilityAnimationComponent,
        ShareFilesStep1FacilitySelectionComponent,
        FacilityUserSelectionMockComponent,
        SendInstructionsComponent,
        RetrieveInstructionsComponent,
        VOBInfoWindowComponent,
        PatientOverviewV2Component,
        PatientOverviewNavigationComponent
    ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        CommonModule,
        DragDropModule,
        MatAutocompleteModule,
        FormsModule,
        MatTreeModule,
        AppRoutingModule,
        MatTooltipModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatMenuModule,
        MatProgressBarModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatIconModule,
        MatInputModule,
        MatChipsModule,
        MatSelectModule,
        MatFormFieldModule,
        MatExpansionModule,
        MatStepperModule,
        MatListModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatGridListModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaterialTimepickerModule,
        MatTableModule,
        MatTabsModule,
        MatCheckboxModule,
        NgxDocViewerModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        MatDialogModule,
        MatSortModule,
        MatRadioModule,
        MsalModule,
        NgxMaskDirective,
        NgxMaskPipe,
        MatPasswordStrengthModule,
        LibraryCategoriesComponent,
        WindowTitleComponent,
        StudiesModule], providers: [
        ...provideNgxMask(),
        AuthService,
        SearchService,
        ReportService,
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },
        { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
        MsalService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
        ...(isProduction && environment.production && environment.config.raygun
            ? [
                {
                    provide: ErrorHandler,
                    useClass: RaygunErrorHandler
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: setupRaygun,
                    multi: true
                }
            ]
            : [{ provide: ErrorHandler, useClass: DevErrorHandler }]),
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ] })
export class AppModule {}
